import { render, staticRenderFns } from "./registerAccount.vue?vue&type=template&id=fc314f14&scoped=true"
import script from "./registerAccount.vue?vue&type=script&lang=js"
export * from "./registerAccount.vue?vue&type=script&lang=js"
import style0 from "./registerAccount.vue?vue&type=style&index=0&id=fc314f14&prod&lang=scss"
import style1 from "./registerAccount.vue?vue&type=style&index=1&id=fc314f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc314f14",
  null
  
)

export default component.exports